import {
    type ViewStyle
} from "react-native";
import type {
    PopoverCloseRadiusConstantType,
    PopoverCloseDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";
import {
    concentric
} from "../../../../helpers/theme/concentric";
import {
    getHitArea
} from "../../../../helpers/theme/control";

export const getPopoverCloseRadius = ({
    controlHeights,
    typography,
    radiuses,
    borders,
    spaces
}: PopoverCloseRadiusConstantType): number => {
    return concentric({
        inset: spaces.spacingMd + (typography.titleSmallSize.lineHeight - controlHeights.small) / 2 + borders.line,
        outer: radiuses.surface,
        role: radiuses.actions
    });
};

export const useStyles = ({
    controlHeights,
    touchTargets,
    pointerType,
    typography,
    iconSizes
}: PopoverCloseDynamicStyleType) => {
    const hitArea = getHitArea({
        visualSize: controlHeights.small,
        touchTargets,
        pointerType
    });

    const styles = {
        close: {
            marginVertical: (typography.titleSmallSize.lineHeight - hitArea.minHeight) / 2,
            marginEnd: (iconSizes.small - hitArea.minWidth) / 2
        } as Mutable<ViewStyle>
    };

    return styles;
};
